import { SamplesFilter } from '../../../../../shared/types/legalProceedings/samples';
import * as Yup from 'yup';

export const initialValues: SamplesFilter = {
    caseId: '',
    pqrId: '',
    startCreatedAt: undefined,
    endCreatedAt: undefined,
    percentage: '',
    status: '',
    type: [],
    area1: '',
    inCharge: '',
    half: [],
};

export const validationSchema = () =>
    Yup.object({
        percentage: Yup.number()
            .typeError('El porcentaje debe ser un número')
            .min(1, 'El porcentaje debe ser al menos 1')
            .max(100, 'El porcentaje no puede ser mayor a 100'),
    });
